import * as React from "react";
import { forwardRef } from "react";
const SvgIconCheckedIndeterminate = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("rect", { x: 1.5, y: 1.5, width: 21, height: 21, rx: 2.5, fill: "#5265FF", stroke: "#182231" }), /* @__PURE__ */ React.createElement("path", { d: "M17 11H7V13H17V11Z", fill: "white" }));
const ForwardRef = forwardRef(SvgIconCheckedIndeterminate);
export { ForwardRef as ReactComponent };
